import { render } from "./CommonAbout.vue?vue&type=template&id=320fdced"
import script from "./CommonAbout.vue?vue&type=script&lang=js"
export * from "./CommonAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__